import React, { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

import MessageLinks from "../components/MessageLinks";
import Nav from "../components/Nav";
import { track } from "../lib/contact";
import data from "../solutions.json";

const solutions = data as unknown as Record<
  string,
  { title: string; headline: string; lead: string; points: string[]; proof: string; faq: [string, string][] }
>;

export default function Solution() {
  const { slug = "" } = useParams();
  const s = solutions[slug];

  useEffect(() => {
    if (!s) return;
    const prev = document.title;
    document.title = `${s.title} — lab.radical`;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content") ?? "";
    meta?.setAttribute("content", s.lead);
    return () => {
      document.title = prev;
      meta?.setAttribute("content", prevDesc);
    };
  }, [s]);

  if (!s) return <Navigate to="/" replace />;

  return (
    <div>
      <Nav />
      <main className="container mx-auto max-w-3xl px-6 pb-40 pt-24">
        <div className="mb-6 text-[10px] font-medium uppercase tracking-[0.18em] text-muted">
          {s.title}
        </div>
        <h1 className="mb-6 font-heading text-[clamp(30px,5vw,52px)] font-bold leading-[1.05] -tracking-[0.03em]">
          {s.headline}
        </h1>
        <p className="mb-10 text-[16px] font-light leading-[1.75] text-muted">{s.lead}</p>
        <ul className="mb-12 flex flex-col">
          {s.points.map((p) => (
            <li key={p} className="border-t border-border py-3 text-[14px] text-text">
              {p}
            </li>
          ))}
        </ul>
        <h2 className="mb-4 font-heading text-[22px] font-bold">Measured, not promised</h2>
        <p className="mb-12 text-[14px] font-light leading-[1.75] text-muted">
          {s.proof}{" "}
          <a
            href="https://clynnbynature.com"
            className="text-text underline-offset-4 hover:underline"
          >
            clynnbynature.com
          </a>
        </p>
        <h2 className="mb-4 font-heading text-[22px] font-bold">Common questions</h2>
        {s.faq.map(([q, a]) => (
          <div key={q} className="mb-5">
            <div className="text-[14px] font-bold">{q}</div>
            <p className="text-[14px] font-light text-muted">{a}</p>
          </div>
        ))}
        <a
          href="/#contact"
          onClick={() => track("cta_click", { where: `solution_${slug}` })}
          className="mt-8 inline-block rounded-full bg-lime px-6 py-3 text-xs font-bold text-bg no-underline hover:opacity-85"
        >
          Get your site rebuilt ↗
        </a>
        <div className="mt-5">
          <MessageLinks where={`solution_${slug}`} />
        </div>
      </main>
    </div>
  );
}
